import { render, staticRenderFns } from "./table.vue?vue&type=template&id=1d5aefe2"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d5aefe2')) {
      api.createRecord('1d5aefe2', component.options)
    } else {
      api.reload('1d5aefe2', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=1d5aefe2", function () {
      api.rerender('1d5aefe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/config_center/view/list/approval/table.vue"
export default component.exports